import {
    BillReceiverAddress,
    BillReceiversFormValuesType,
    BillReceiversType,
    CountryCode,
    isPrivateCompanyDetails,
    isPrivatePersonDetails,
    isPublicInstitutionDetails,
    SendInvoiceCompany,
} from "../billReceiversTypes"
import { BillReceiverType } from "../../../organization/userGroups/userGroupsTypes"
import { CreateBillReceiversParams } from "../billReceiversApi"

export function billReceiverToApi(
    formValues: BillReceiversFormValuesType,
    billType: BillReceiversType | null,
    endpointValue?: string,
    endpointType?: SendInvoiceCompany,
): CreateBillReceiversParams | undefined {
    const address: BillReceiverAddress = {
        country: {
            countryCode: formValues.country === CountryCode.DA ? "DK" : formValues.country,
        },
        postalCode: formValues.postalCode,
        city: formValues.city,
        addressLines: [formValues.addressLine1],
    }

    if (formValues.addressLine2) {
        address.addressLines.push(formValues.addressLine2)
    }

    const baseBillReceiver = {
        debitorNo: formValues.debtorNumber,
        address,
        isActive: true, // Assuming newly created bill receivers are active by default
    }

    switch (billType) {
        case BillReceiversType.PRIVATE_PERSON:
            if (isPrivatePersonDetails(formValues)) {
                return {
                    billReceiver: {
                        ...baseBillReceiver,
                        endpoint: {
                            type: BillReceiverType.EMAIL_ADDRESS,
                            email: endpointValue,
                        },
                        type: BillReceiversType.PRIVATE_PERSON,
                        name: formValues.name,
                    },
                }
            }
            return

        case BillReceiversType.PUBLIC_INSTITUTION:
            if (isPublicInstitutionDetails(formValues)) {
                return {
                    billReceiver: {
                        ...baseBillReceiver,
                        type: BillReceiversType.PUBLIC_INSTITUTION,
                        name: formValues.institutionName,
                        endpoint: {
                            type: BillReceiverType.EAN_NUMBER,
                            eanNumber: endpointValue,
                        },
                        contact: {
                            name: formValues.contactPerson,
                            email: formValues.email,
                            phone: formValues.telephone,
                        },
                    },
                }
            }
            return

        case BillReceiversType.PRIVATE_COMPANY:
            if (isPrivateCompanyDetails(formValues)) {
                return {
                    billReceiver: {
                        ...baseBillReceiver,
                        type: BillReceiversType.PRIVATE_COMPANY,
                        name: formValues?.companyName,
                        endpoint: {
                            type: endpointType?.invoiceType,
                            ...(endpointType?.invoiceType === BillReceiverType.EAN_NUMBER && {
                                eanNumber: endpointType.search,
                            }),
                            ...(endpointType?.invoiceType === BillReceiverType.EMAIL_ADDRESS && {
                                email: endpointType.search,
                            }),
                        },
                        cvrNumber: endpointValue,
                        contact: {
                            name: formValues.contactPerson,
                            email: formValues.email,
                            phone: formValues.telephone,
                        },
                    },
                }
            }
            return

        default:
            throw new Error(`Unknown bill receiver type: ${billType}`)
    }
}
